import _asyncToGenerator from "/Users/lacassiano.sugiyama/Workspace/peloton/git/web-tv/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/asyncToGenerator.js";
import _defineProperty from "/Users/lacassiano.sugiyama/Workspace/peloton/git/web-tv/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js";
import _toConsumableArray from "/Users/lacassiano.sugiyama/Workspace/peloton/git/web-tv/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/toConsumableArray.js";
var __jsx = React.createElement;
import _regeneratorRuntime from "/Users/lacassiano.sugiyama/Workspace/peloton/git/web-tv/node_modules/next/dist/compiled/@babel/runtime/regenerator/index.js";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

import { useRouter } from 'next/router';
import React from 'react';
import useSWR from 'swr';
import { toNowTime, toTime } from '@peloton/time';
import { updateContractAgreements } from '@engage/api-v2';
import { getOkValue } from '@engage/result';
import { LogoutEvent, useIsLoggedIn, useLogout } from '@webtv/auth';
import { UsersFetchers } from '@webtv/data-fetch';
import { engageApi } from '@webtv/data-fetch/singletons';
import { PELOTON_PLATFORM } from '@webtv/env';
import { InternationalizeProvider } from '@webtv/internationalize';
import { FullScreenSpinner } from '@webtv/shared-ui';
import { TermsTakeoverView } from './ui/TermsTakeoverView';
import { Fragment as _Fragment } from "react/jsx-runtime";
import { jsx as _jsx } from "react/jsx-runtime";
var TermsTakeoverWhitelist = ['/welcome', '/error', '/reset-password', '/terms', '/choose-username', '/create-account', '/free-trial', '/login', '/subscription'];
export var TermsTakeover = function TermsTakeover(_ref) {
  var _user$contractAgreeme, _user$contractAgreeme2;

  var children = _ref.children;
  var router = useRouter();
  var logout = useLogout(engageApi, LogoutEvent.Account); //Todo

  var _useIsLoggedIn = useIsLoggedIn(),
      isLoggedIn = _useIsLoggedIn.isLoggedIn;

  var _useSWR = useSWR.apply(void 0, _toConsumableArray(UsersFetchers.GetMe({
    pelotonPlatform: PELOTON_PLATFORM
  }))),
      user = _useSWR.data,
      mutate = _useSWR.mutate;

  var unacceptedContracts = (_user$contractAgreeme = user === null || user === void 0 ? void 0 : (_user$contractAgreeme2 = user.contractAgreements) === null || _user$contractAgreeme2 === void 0 ? void 0 : _user$contractAgreeme2.filter(function (contract) {
    return contract.agreedAt === null;
  }).map(function (contract) {
    var _contract$contractCre;

    return _objectSpread(_objectSpread({}, contract), {}, {
      displayName: contract.contractDisplayName,
      onDocSelected: function onDocSelected() {
        return router.push({
          pathname: "/terms/".concat(contract.contractType)
        });
      },
      createdAt: toTime((_contract$contractCre = contract.contractCreatedAt) !== null && _contract$contractCre !== void 0 ? _contract$contractCre : 0)
    });
  })) !== null && _user$contractAgreeme !== void 0 ? _user$contractAgreeme : [];
  var now = toNowTime().unix();

  var acceptTerms = /*#__PURE__*/function () {
    var _ref2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
      var _user$contractAgreeme3;

      var contractAgreements, updatedAgreements, _user$id;

      return _regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              contractAgreements = unacceptedContracts.map(function (contract) {
                return {
                  contractId: contract.contractId,
                  agreedAt: now
                };
              });
              updatedAgreements = user === null || user === void 0 ? void 0 : (_user$contractAgreeme3 = user.contractAgreements) === null || _user$contractAgreeme3 === void 0 ? void 0 : _user$contractAgreeme3.map(function (contract) {
                return contract.agreedAt === null ? _objectSpread(_objectSpread({}, contract), {}, {
                  agreedAt: now
                }) : contract;
              });

              if (!contractAgreements) {
                _context.next = 6;
                break;
              }

              _context.next = 5;
              return updateContractAgreements(engageApi, (_user$id = user === null || user === void 0 ? void 0 : user.id) !== null && _user$id !== void 0 ? _user$id : '', {
                contractAgreements: contractAgreements
              }, PELOTON_PLATFORM);

            case 5:
              mutate(_objectSpread(_objectSpread({}, user), {}, {
                contractAgreements: updatedAgreements
              }));

            case 6:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    }));

    return function acceptTerms() {
      return _ref2.apply(this, arguments);
    };
  }();

  if (TermsTakeoverWhitelist.find(function (path) {
    return router.pathname.startsWith(path);
  }) !== undefined) {
    return /*#__PURE__*/_jsx(_Fragment, {
      children: children
    });
  }

  if (getOkValue(isLoggedIn) && user === undefined) {
    return /*#__PURE__*/_jsx(FullScreenSpinner, {});
  }

  if (unacceptedContracts.length > 0) {
    return /*#__PURE__*/_jsx(InternationalizeProvider, {
      page: "terms",
      pelotonPlatform: PELOTON_PLATFORM,
      children: /*#__PURE__*/_jsx(TermsTakeoverView, {
        docsToShow: unacceptedContracts,
        onContinueSelected: acceptTerms,
        logout: logout
      })
    });
  }

  return /*#__PURE__*/_jsx(_Fragment, {
    children: children
  });
};